import { TableCellValue } from "@/src/components/Table/types";
import { formatStandardNumber } from "@/src/helpers/numberFormatters";
import { TokenAttributeRarity } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/routes/tokens/routes/[tokenId]/types";
import { TokenMetadataType } from "@/src/types";

export const DETAILS_TAB_HEADER_DETAILS = "details";
export const DETAILS_TAB_HEADER_VALUE = "value";

export const TOKEN_METADATA__ROW_DETAILS_REVEALED_COLLECTION_SIZE =
  "Revealed Collection Size";
export const TOKEN_METADATA_ROW_DETAILS_REVEALED_UNITS = "Revealed Units";
export const TOKEN_METADATA_ROW_DETAILS_RARITY = "Rarity";
export const TOTAL_COLLECTION_SIZE = "Total Collection Size";
export const TOTAL_UNITS = "Total Units";

export const combineTokenDataAndTokenAttributeData = (
  properties: TokenMetadataType["attributes"],
  tokenRarityAttributes?: Record<string, TokenAttributeRarity>,
) => {
  return properties.map(
    ({ trait_type: traitType, display_type: displayType, value }) => {
      const rarity =
        tokenRarityAttributes && tokenRarityAttributes[traitType]
          ? tokenRarityAttributes[traitType]
          : { value, traitType };
      return {
        ...rarity,
        displayType,
      };
    },
  );
};

export const getDetailsTabTokenMetadataRows = (
  tokenMetadata: TokenMetadataType,
) => {
  const tokenUnits = tokenMetadata.rarity?.tokenUnits;
  const tokenUnitsFormatted = tokenUnits && formatStandardNumber(tokenUnits);
  const tokenMetadataRowMap = [
    {
      [DETAILS_TAB_HEADER_DETAILS]:
        TOKEN_METADATA__ROW_DETAILS_REVEALED_COLLECTION_SIZE,
      [DETAILS_TAB_HEADER_VALUE]:
        !!tokenMetadata.rarity?.collectionSize &&
        `${tokenMetadata.rarity?.collectionSize}`,
    },
    {
      [DETAILS_TAB_HEADER_DETAILS]: TOKEN_METADATA_ROW_DETAILS_REVEALED_UNITS,
      [DETAILS_TAB_HEADER_VALUE]: !!tokenUnits && `${tokenUnitsFormatted}`,
    },
    {
      [DETAILS_TAB_HEADER_DETAILS]: TOKEN_METADATA_ROW_DETAILS_RARITY,
      [DETAILS_TAB_HEADER_VALUE]: !!tokenUnits && `1 of ${tokenUnitsFormatted}`,
    },
  ];

  const tokenMetadataRows = tokenMetadataRowMap.map((row) => {
    if (!row[DETAILS_TAB_HEADER_VALUE]) return [];

    const formattedRow = [
      {
        key: DETAILS_TAB_HEADER_DETAILS,
        value: row[DETAILS_TAB_HEADER_DETAILS],
      },
      { key: DETAILS_TAB_HEADER_VALUE, value: row[DETAILS_TAB_HEADER_VALUE] },
    ];

    return formattedRow;
  });

  return tokenMetadataRows;
};

export const ROW_TOOLTIP_MAP = {
  [TOTAL_COLLECTION_SIZE.toLowerCase()]:
    "The total number of Nike Virtual Creations in the collection. Some of these Nike Virtual Creations may not have been revealed yet.",
  [TOKEN_METADATA__ROW_DETAILS_REVEALED_COLLECTION_SIZE.toLowerCase()]:
    "The number of revealed Nike Virtual Creations in the collection.",
  [TOTAL_UNITS.toLowerCase()]:
    "The total number of other Nike Virtual Creations in the collection with the same exact properties as this Nike Virtual Creation. Some of these Nike Virtual Creations may not have been revealed yet.",
  [TOKEN_METADATA_ROW_DETAILS_REVEALED_UNITS.toLowerCase()]:
    "The number of revealed Nike Virtual Creations in the collection with the same exact properties as this Nike Virtual Creation.",
  [TOKEN_METADATA_ROW_DETAILS_RARITY.toLowerCase()]:
    "The uniqueness score of this Nike Virtual Creation. Calculated as 1 of X where X equals revealed token units with the same exact properties as this Nike Virtual Creation.",
};

export const getRowsWithTooltips = (rows: TableCellValue[][]) => {
  if (!rows) return;
  return rows.map((row) =>
    row.map((cell) => ({
      ...cell,
      // Adds tooltip copy to the array if the row has a corresponding tooltip
      tooltipCopy:
        typeof cell.value === "string"
          ? ROW_TOOLTIP_MAP[cell.value.toLowerCase()]
          : "",
    })),
  );
};
